export const classCssTiers = {
  GOLD: 'gold',
  PLATINUM: 'platinum',
  TITANIUM: 'titanium',
  SILVER: 'silver',
  'CABALLERO AGUILA': 'caballero',
  CA: 'caballero',
};

export const cobrandLevels = {
  AMXPLT: 'texto',
  SANTANDER: 'texto',
};

const COBRAND_PATTERNS = {
  INBURSA: ['SFIDBT', 'SFIASC', 'SFIASA', 'SFIELE', 'SFIELA', 'SFIHRZ', 'SFIHRA', 'INBURSA', 'INB'],
  AMEX: ['AMXPLT', 'AMXGLD', 'AMXGRN', 'AMX', 'AMEX'],
  SANTANDER: ['SECLAS', 'SEPLAT', 'SEIFNT', 'SANTANDER', 'SNT', 'SAN'],
} as const;

export const COBRAND_SPECIFIC_LABELS: Record<string, string> = {
  SFIDBT: 'Débito Cuenta Inbursa-Aeroméxico',
  SFIASC: 'Inbursa-Aeroméxico Ascend',
  SFIASA: 'Inbursa-Aeroméxico Ascend',
  SFIELE: 'Inbursa-Aeroméxico Elevate',
  SFIELA: 'Inbursa-Aeroméxico Elevate',
  SFIHRZ: 'Inbursa-Aeroméxico Horizon',
  SFIHRA: 'Inbursa-Aeroméxico Horizon',
  AMXGRN: 'American Express Aeroméxico',
  AMXGLD: 'American Express Aeroméxico Gold',
  AMXPLT: 'American Express Aeroméxico Platinum',
  SECLAS: 'Santander Aeroméxico',
  SEPLAT: 'Santander Aeroméxico Platinum',
  SEIFNT: 'Santander Aeroméxico Infinite',
};

const COBRAND_LABELS: Record<string, string> = {
  INBURSA: 'Tarjeta Inbursa Aeroméxico',
  AMEX: 'American Express Aeroméxico',
  SANTANDER: 'Santander Aeroméxico',
};

const COBRAND_LOGOS: Record<string, string> = {
  INBURSA: './assets/images/bags/benefit-inbursa.svg',
  AMEX: './assets/images/bags/benefit-amex.svg',
  SANTANDER: './assets/images/bags/benefit-santander.svg',
};

type ValidCobrandKey = keyof typeof COBRAND_PATTERNS;
type CobrandKey = ValidCobrandKey | 'UNKNOWN';

export const COBRAND_REDEN_BENEFIT_TEXTS: Record<ValidCobrandKey, string> = {
  INBURSA: 'Inbursa',
  AMEX: 'American Express',
  SANTANDER: 'Santander',
};

export function detectCobrand(code: string): CobrandKey {
  const upper = (code || '').toUpperCase();
  for (const [key, patterns] of Object.entries(COBRAND_PATTERNS)) {
    if (patterns.some((p) => upper.includes(p))) return key as CobrandKey;
  }
  return 'UNKNOWN';
}

export function getCobrandLabel(cobrandCode: string): string {
  const upper = (cobrandCode || '').toUpperCase();
  return COBRAND_SPECIFIC_LABELS[upper] || COBRAND_LABELS[detectCobrand(cobrandCode)] || cobrandCode;
}

export function getCobrandLogo(cobrandCode: string): string {
  return COBRAND_LOGOS[detectCobrand(cobrandCode)] || './assets/images/bags/benefit-rewards.svg';
}

type BenefitType = 'tier' | 'cobrand' | 'corporate' | 'f&f' | null;

export interface PassengerBenefitInfo {
  typeCobrand: BenefitType;
  typeTier: BenefitType;
  typeCorporate: BenefitType;
  typeff: BenefitType;
  benefits?: { cobrandCode?: string; tier?: string };
}

export interface CobrandResult {
  type: string;
  label: string;
  logo: string;
}

/** Prioridad de tarjetas: Inbursa > AMEX > Santander > Tier > Corporate > F&F */
export function resolveCobrandPriority(passenger: PassengerBenefitInfo): CobrandResult {
  if (!passenger) {
    return { type: '', label: '', logo: '' };
  }
  const code = (passenger.benefits?.cobrandCode || '').toUpperCase();
  if (passenger.typeCobrand && code) {
    return { type: 'cobrand', label: getCobrandLabel(code), logo: getCobrandLogo(code) };
  }
  if (passenger.typeTier) {
    const tier = passenger.benefits?.tier || '';
    return {
      type: 'tier',
      label: `Aeroméxico Rewards ${tier}`,
      logo: './assets/images/bags/benefit-rewards.svg',
    };
  }
  if (passenger.typeCorporate) {
    return {
      type: 'corporate',
      label: 'Aeroméxico Rewards',
      logo: './assets/images/bags/benefit-rewards.svg',
    };
  }
  if (passenger.typeff) {
    return {
      type: 'f&f',
      label: 'Aeroméxico Rewards',
      logo: './assets/images/bags/benefit-rewards.svg',
    };
  }
  return { type: '', label: '', logo: '' };
}
